<div class="component-content">
    <div class="grid-fixed-container">
        <div class="section-header">
            <span class="header">Mapping rules</span>
            <button class="lc-stroked-button add-button" *ngIf="accessService.canMaintainMappingsOfCustomers()" (click)="openAddDialog()"
                mat-stroked-button>
                <mat-icon svgIcon="add-circle"></mat-icon>Add
            </button>
        </div>
    </div>
    <div class="grid-scrollable-container">
        <table class="lc-table" mat-table [dataSource]="dataSource" matSort>
            
            <!-- Mapping name column -->
            <ng-container matColumnDef="mappingName">
                <th mat-header-cells *matHeaderCellDef mat-sort-header>Mapping</th>
                <td mat-cell *matCellDef="let element"> {{element.mappingName}} </td>
            </ng-container>

            <!-- Target path column -->
            <ng-container matColumnDef="targetPath">
                <th mat-header-cells *matHeaderCellDef mat-sort-header>Target path</th>
                <td mat-cell *matCellDef="let element"> {{element.targetPath}} </td>
            </ng-container>

            <!-- Edit view column -->
            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="accessService.canMaintainMappingsOfCustomers()" (click)="openEditDialog(element.id)"
                        mat-button color="primary" title="Edit">
                        <mat-icon>mode_edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Delete view column -->
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="accessService.canMaintainMappingsOfCustomers()" mat-button color="primary"
                        title="Delete" (click)="removeRule(element.id)">
                        <mat-icon svgIcon="delete"></mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="dataSource.data.length===0">No data to display</td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5,10,15]"></mat-paginator>
</div>
